<template>
  <base-section
  id="lyon"
  >
    <v-container>
    <base-section-heading
    title="City of Lyon"
    color="red"
    align="left"
    :toColor="true"
    >

DDECS'25 will be held in the city of Lyon, which offers a blend of historical charm, culinary delights, cultural richness, and modern amenities. <br /> <br />

    </base-section-heading>
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.src"
        contain
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        />
      </v-carousel-item>
    </v-carousel>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Lyon',

    data: () => ({
      slides: [
        {
          src: require('@/images/venue/lyon07.jpg'),
        },
        {
          src: require('@/images/venue/lyon03.jpg'),
        },
        {
          src: require('@/images/venue/lyon02.jpg'),
        },
        {
          src: require('@/images/venue/lyon04.jpg'),
        },
        {
          src: require('@/images/venue/lyon05.jpg'),
        },
        {
          src: require('@/images/venue/lyon01.jpg'),
        },
        {
          src: require('@/images/venue/lyon06.jpg'),
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
